var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunWhite(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sun-white_svg__clip0_39_185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875 0v1.875h1.25V0h-1.25zM2.639 1.755l-.884.884 1.326 1.326.884-.884-1.326-1.326zm9.722 0l-1.326 1.326.884.884 1.326-1.326-.884-.884zM7.5 3.125A4.385 4.385 0 003.125 7.5 4.385 4.385 0 007.5 11.875 4.385 4.385 0 0011.875 7.5 4.385 4.385 0 007.5 3.125zm0 1.25A3.116 3.116 0 0110.625 7.5 3.116 3.116 0 017.5 10.625 3.116 3.116 0 014.375 7.5 3.116 3.116 0 017.5 4.375zM0 6.875v1.25h1.875v-1.25H0zm13.125 0v1.25H15v-1.25h-1.875zm-10.044 4.16l-1.326 1.326.884.884 1.326-1.326-.884-.884zm8.838 0l-.884.884 1.326 1.326.884-.884-1.326-1.326zm-5.044 2.09V15h1.25v-1.875h-1.25z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sun-white_svg__clip0_39_185"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15v15H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunWhite);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "70e5e60ad40e2fadd521d0fd989c73a8.svg";
export { MemoForwardRef as ReactComponent };